import { Select, FormLabel, Loader, Heading } from "@/components";
import useManageBOM from "./useManageBOM";
import { Tabs, TabsTrigger, TabsList, TabsContent } from "@/components/ui/tabs";
import { PositionConfig } from "./PositionConfig";
import { BOMs } from "./BOMs";
import { tabs } from "./consts";
import { ApprovalLimits } from "./ApprovalLimits";

const ManageBOM = () => {
  const {
    onCommunityChange,
    isCommunityLoading,
    communityId,
    communityKey,
    communityList,
  } = useManageBOM();
  return (
    <div className="p-4 md:p-6">
      {isCommunityLoading ? (
        <Loader />
      ) : (
        <>
          {/* Header & Search */}
          <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
            <div className="flex flex-row items-center justify-between">
              <Heading title="Manage BM" />
            </div>
            <div className="relative col-span-2 w-full sm:w-72 sm:min-w-72 sm:max-w-72 shrink-0">
              <FormLabel>Select Community</FormLabel>
              <Select
                key={communityKey}
                placeholder={""}
                searchPlaceholder={""}
                noDataPlaceholder={"Community No Found"}
                options={communityList?.data?.map((data: any) => ({
                  value: data?.communityId?.toString(),
                  label: data?.name,
                }))}
                value={communityId?.toString()}
                onChange={onCommunityChange}
                className="h-[36px] w-full"
              />
            </div>
          </div>

          <Tabs defaultValue="positions" className="w-full my-4">
            <TabsList className="gap-x-4">
              {tabs?.map((data: any) => (
                <TabsTrigger
                  key={data?.value}
                  value={data?.value}
                  className="hover:cursor-pointer text-gray-400 px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-black"
                >
                  {data?.title}
                </TabsTrigger>
              ))}
            </TabsList>
            <TabsContent value="positions" className="w-full">
              <PositionConfig />
            </TabsContent>
            <TabsContent value="bom" className="w-full">
              <BOMs />
            </TabsContent>
            <TabsContent value="approvalLimit" className="w-full">
              <ApprovalLimits />
            </TabsContent>
          </Tabs>
        </>
      )}
    </div>
  );
};

export default ManageBOM;
